const {AoflElement, store, abcmouseTrackerQueue} = aofljs;
/**
 * @summary CreateShortcutMacPopup
 * @class CreateShortcutMacPopup
 * @extends {AoflElement}
 */
class CreateShortcutMacPopup extends AoflElement {
  /**
   * Creates an instance of CreateShortcutMacPopup.
   * Stores svgs in properties.
   *
   * @memberof CreateShortcutMacPopup
   */
  constructor() {
    super(store);
  }

  /**
   *
   * @readonly
   * @static
   * @memberof CreateShortcutMacPopup
   */
  static get is() {
    return 'create-shortcut-mac-popup';
  }

  /**
   *
   * @memberof CreateShortcutMacPopup
   */
  connectedCallback() {
    super.connectedCallback();
    abcmouseTrackerQueue.enqueueEvent({
      url: this.pageInfo.pageLoadUrl,
      page_info_key: this.pageInfo.page_info_key
    });
  }

  /**
   *
   * @readonly
   * @static
   * @memberof CreateShortcutMacPopup
   */
  static get properties() {
    return {
      pageInfo: {
        type: Object,
        value: {
          pageLoadUrl: 'homepage',
          page_info_key: 'create_shortcut_popup'
        }
      }
    };
  }

  /**
   *
   *
   * @param {any} e
   * @memberof CreateShortcutMacPopup
   */
  handleLinkDragStart(e) {
    let abcmouseDraggable = this.$['abcmouse-draggable-one'];
    e.dataTransfer.clearData();
    e.dataTransfer.setData('text/plain', 'https://www.abcmouse.com');
    e.dataTransfer.setDragImage(abcmouseDraggable, 25, 25);
  }
}

window.customElements.define(CreateShortcutMacPopup.is, CreateShortcutMacPopup);

export default CreateShortcutMacPopup;



// WEBPACK FOOTER //
// ./home/en-US/js/create-shortcut-mac-popup/create-shortcut-mac-popup.js